export const GROUP_LEADER = 20; // 
export const WATCH_WEBINAR_MODE = 1; // 音频直播静音

// 互动流类型
export const STREAM_TYPE_PURE_VOICE = 0; // 纯音频
export const STREAM_TYPE_PURE_VIDEO = 1; // 纯视频
export const STREAM_TYPE_VOICE_VIDEO = 2; // 音视频
export const STREAM_TYPE_SCREEN_SHARE = 3; // 屏幕共享
export const STREAM_TYPE_VOICE_TURNING = 5; // 视频轮训

// 旁路布局
const RTC_VIDEO_PROFILE_720P = 'RTC_VIDEO_PROFILE_720P_16x9_M';
const RTC_VIDEO_PROFILE_540P = 'RTC_VIDEO_PROFILE_540P_16x9_M';
const RTC_VIDEO_PROFILE_480P = 'RTC_VIDEO_PROFILE_480P_16x9_M';
const RTC_VIDEO_PROFILE_360P = 'RTC_VIDEO_PROFILE_360P_16x9_M';
const RTC_VIDEO_PROFILE_240P = 'RTC_VIDEO_PROFILE_240P_16x9_M';
const RTC_VIDEO_PROFILE_180P = 'RTC_VIDEO_PROFILE_180P_16x9_M';
const RTC_VIDEO_PROFILE_120P = 'RTC_VIDEO_PROFILE_120P_16x9_M';
const RTC_VIDEO_PROFILE_MAP = {
	'720': RTC_VIDEO_PROFILE_720P,
	'高清': RTC_VIDEO_PROFILE_720P,
	'540': RTC_VIDEO_PROFILE_540P,
	'480': RTC_VIDEO_PROFILE_480P,
	'高清': RTC_VIDEO_PROFILE_480P,
	'360': RTC_VIDEO_PROFILE_360P,
	'标清': RTC_VIDEO_PROFILE_360P,
	'240': RTC_VIDEO_PROFILE_240P,
	'流畅': RTC_VIDEO_PROFILE_240P,
	'180': RTC_VIDEO_PROFILE_180P,
	'120': RTC_VIDEO_PROFILE_120P
};
/**
 * 获取旁路布局
 * @param { string } param [字符串 120，240，360，480]
 * @returns { String } [互动sdk推流Profile常量]
 */
export const formatDefinition = (param) => {
	return RTC_VIDEO_PROFILE_MAP[param] || RTC_VIDEO_PROFILE_360P;
};
